<template>
  <li v-bind="$attrs" :class="ordered ? $style.orderedListItem : $style.listItem">
    <slot />
  </li>
</template>

<script setup lang="ts">

defineProps({
  ordered: { type: Boolean, default: false }
})
</script>

<style module>
.listItem {
  &+& {
    margin-top: var(--space-sm);
  }

  /* TODO: check options for dynamic min width property */
  @media screen and (min-width: 740px) {
    &+& {
      margin-top: var(--space-md);
    }
  }
}

.orderedListItem {
  font-size: 16px;
  line-height: 19px;
  position: relative;
  display: flex;
  align-items: flex-start;
  counter-increment: item;
  padding-left: 0;
  list-style-position: inside;
  margin-bottom: 20px;

  :before {
    content: counters(item, '.');
    font-family: var(--font-heading);
    font-size: 14px;
    line-height: 14px;
    margin-top: 2px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    min-width: 20px;
    color: var(--color-white);
    background-color: var(--color-grey5);
    border-radius: 50%;
  }
}
</style>
